<template>
  <div class="form-container">
    <!-- 电脑端使用 Element UI 表单 -->
    <section v-if="isDesktop" style="padding:0 5%;">
      <el-form
        ref="form"
        label-position="top"
        status-icon
        :model="form"
        :rules="rules"
        label-width="100px"
        style="width:100%;"
      >
        <el-form-item label="标签标识" prop="tag_id" required>
          <el-input v-model="form.tag_id" placeholder="请输入标签标识,不可重复"></el-input>
        </el-form-item>

        <el-form-item label="标签名" prop="name" required>
          <el-input v-model="form.name" placeholder="请输入标签名称"></el-input>
        </el-form-item>

        <el-form-item label="标签颜色" prop="color">
          <el-color-picker
            v-model="form.color"
            show-alpha
            :predefine="predefineColors">
          </el-color-picker>
        </el-form-item>

        <el-form-item label="标签描述" prop="description">
          <el-input v-model="form.description" placeholder="请输入标签描述"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="submit('form')" :plain="true">立即添加</el-button>
        </el-form-item>
      </el-form>
    </section>

    <!-- 手机端使用 Vant 表单 -->
    <div v-else class="mobile-form-container">
      <div class="mobile-form-content">
        <van-form ref="mobileForm" :model="form" :rules="rules" @submit="onMobileSubmit">
          <van-cell-group inset>
            <!-- 标签标识 -->
            <van-field
              v-model="form.tag_id"
              name="tag_id"
              label="标签标识"
              input-align="right"
              placeholder="请输入标签标识,不可重复"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 标签名 -->
            <van-field
              v-model="form.name"
              name="name"
              label="标签名"
              input-align="right"
              placeholder="请输入标签名称"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 标签颜色 -->
            <van-cell title="标签颜色" is-link @click="openColorPicker">
              <template #right-icon>
                <div style="display: flex; align-items: center;">
                  <div :style="{ backgroundColor: form.color, width: '16px', height: '16px', borderRadius: '3px', marginRight: '8px' }"></div>
                  <span>{{ form.color || '请选择' }}</span>
                </div>
              </template>
            </van-cell>
            
            <!-- 标签描述 -->
            <van-field
              v-model="form.description"
              name="description"
              label="标签描述"
              input-align="right"
              placeholder="请输入标签描述"
              :validate-trigger="['onChange', 'onBlur']"
            />
          </van-cell-group>
          
          <!-- 颜色选择器 -->
          <van-popup v-model="showColorPicker" position="bottom" :round="true" get-container="body">
            <div class="color-picker-container">
              <div class="color-picker-header">
                <h3>选择颜色</h3>
                <van-icon name="cross" @click="closeColorPicker" class="close-icon" />
              </div>
              <div class="color-picker-content">
                <div class="predefined-colors">
                  <div
                    v-for="(color, index) in predefineColors"
                    :key="index"
                    class="predefined-color-item"
                    :style="{ backgroundColor: color }"
                    @click="selectColor(color)"
                  ></div>
                </div>
              </div>
              <div class="color-picker-actions">
                <van-button type="default" block @click="closeColorPicker">取消</van-button>
              </div>
            </div>
          </van-popup>
        </van-form>
      </div>
      
      <!-- 手机端固定底部按钮 -->
      <div class="mobile-form-actions">
        <van-button type="default" block @click="close">取消</van-button>
        <van-button type="primary" block @click="onMobileSubmit">立即添加</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  let _this;
  import {addTag,getPermissions} from "@/api/system.js";
  import { Field, Cell, CellGroup, Popup, Form, Button, Toast, Icon } from 'vant';
  
  let form = {
          tag_id: "",
          name: "",
          description: '',
          color:"",
          
        }
  export default {
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Popup.name]: Popup,
      [Form.name]: Form,
      [Button.name]: Button,
      [Icon.name]: Icon
    },
    
    data() {
      return {
        isDesktop: true,
        form: form,

        rules: {
          tag_id: [
            {required: true, message: "请输入标签标识,不可重复", trigger: "blur"},
          ],
          name: [
            {required: true, message: "请输入标签名称", trigger: "blur"},
          ]
        },

        predefineColors:[
          '#ff4500',
          '#ff8c00',
          '#ffd700',
          '#90ee90',
          '#00ced1',
          '#1e90ff',
          '#c71585',
          'rgba(255, 69, 0, 0.68)',
          'rgb(255, 120, 0)',
          '#ffff00',
          'rgba(0, 255, 0, 0.5)',
          '#00ced1',
          'rgba(30, 144, 255, 0.73)',
          '#c7158577'
        ],
        
        // 手机端选择器
        showColorPicker: false,
        // 保存当前颜色，用于取消选择时恢复
        tempColor: ''
      };
    },

    computed: {},

    mounted() {
      _this = this;
      _this.init();
      this.checkScreenSize();
      window.addEventListener('resize', this.handleResize);
    },
    
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      // 检查屏幕大小
      checkScreenSize() {
        this.isDesktop = window.innerWidth > 768;
      },
      
      // 处理窗口大小变化
      handleResize() {
        this.checkScreenSize();
      },
      
      // 初始化数据
      init() {
        // getPermissions().then(res=>{
        //   if(res.code === 200){
        //     this.permission = res.data
        //   }
        // })
      },
     
      close() {
        _this.$emit("close");
      },
      
      // 电脑端提交
      submit(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            addTag(_this.form).then(res => {
              if (res.code === 200) {
                _this.$message({
                  message: "添加成功",
                  type: "success"
                });
                this.form = JSON.parse(JSON.stringify(form));
                setTimeout(() => {
                  _this.$emit("success");
                  _this.$emit("close");
                }, 1000);
              }
            })
          } else {
            return false;
          }
        })
      },
      
      // 手机端提交
      onMobileSubmit() {
        this.$refs.mobileForm.validate().then(() => {
          // 验证通过，提交数据
          addTag(this.form).then(res => {
            if (res.code === 200) {
              Toast({
                message: '添加成功',
                type: 'success',
                duration: 1500
              });
              setTimeout(() => {
                this.$emit("success");
                this.$emit("close");
                this.form = JSON.parse(JSON.stringify(form));
              }, 1500);
            } else {
              Toast({
                message: res.message || '添加失败',
                type: 'fail',
                duration: 1500
              });
            }
          }).catch(error => {
            Toast({
              message: '网络错误，请稍后重试',
              type: 'fail',
              duration: 1500
            });
          });
        }).catch(errorInfo => {
          // 验证失败
          console.log('表单验证失败：', errorInfo);
        });
      },
      
      // 打开颜色选择器
      openColorPicker() {
        // 保存当前颜色，用于取消选择时恢复
        this.tempColor = this.form.color;
        this.showColorPicker = true;
      },
      
      // 关闭颜色选择器
      closeColorPicker() {
        // 取消选择，恢复原来的颜色
        this.form.color = this.tempColor;
        this.showColorPicker = false;
      },
      
      // 选择颜色
      selectColor(color) {
        this.form.color = color;
        this.showColorPicker = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
  .form-container {
    width: 100%;
    height: 100%;
  }

  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }

  .icon-dialog {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .icon-dialog-list {
      box-sizing: border-box;
      padding: 20px 10px;
      width: 16.66%;
      font-size: 32px;
      text-align: center;
      border: 1px solid #dbdbdb;
    }
    .icon-dialog-list:hover {
      color: #409eff;
      border-color: #409eff;
    }
  }

  .icon-name {
    margin-top: 10px;
    font-size: 12px;
  }

  // 手机端样式
  .mobile-form-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .mobile-form-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 45px;
  }

  .mobile-form-actions {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
  }

  .mobile-form-actions .van-button {
    flex: 1;
    height: 44px;
    font-size: 16px;
  }

  // 颜色选择器样式
  .color-picker-container {
    padding: 15px;
  }

  .color-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .color-picker-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }

  .color-picker-header .close-icon {
    font-size: 20px;
    color: #999;
  }

  .predefined-colors {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
  }

  .predefined-color-item {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease;
  }

  .predefined-color-item:hover {
    border-color: #409eff;
    transform: scale(1.1);
  }

  .color-picker-actions {
    margin-top: 20px;
  }
  
</style>
<style>
  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
</style>
